export default "__VITE_ASSET__CIiAoUAS__"